import type { SmokeballAuthenticator } from "../../services/smokeball-authenticator";
import { SecondarySubtleButton } from "../Primitives/Buttons";

export interface TProps {
  authenticator: SmokeballAuthenticator | null;

  logout: () => void;
}

export const LogoutPresentational = (props: TProps) => (
  <div className="flex justify-between items-center p-1 bg-white">
    <span className="ml-3 mr-5 text-align-left">1.0.75</span>
    <SecondarySubtleButton className="text-align-right" onClick={props.logout}>
      Logout
    </SecondarySubtleButton>
  </div>
);
